import { post } from "../https";

const SERVER_URL = process.env.REACT_APP_HIRE_SIDE_API;

export const GetNewsInfo = (
  NewsCode = "",
  AccessToken = "",
  moreParams = {},
  countryCode
) => {
  let params = {
    r: "News",
    rt: "GetNewsInfo",
    p: JSON.stringify({
      NewsCode,
      AccessToken: AccessToken,
      IPCountry: countryCode,
    }),
  };

  return post(SERVER_URL, null, params, moreParams);
};
